<template>

<core-panel>

	<template v-slot:head>

		<h1>Average Weight</h1>

		<p>The average weight of each players games.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in players" :subtext="'Average weight of ' + item.weight" count-text="play" :key="index" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'weight',
			players: []
		}

	},

	methods: {

		response: function(json) {

			this.players = json.weights.players

		}

	}

}

</script>